"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Authorization extends Api_1.default {
    /**
     * @constructor
     */
    constructor(props) {
        super(props);
    }
    /**
     *
     * @see https://developers.podio.com/doc/oauth-authorization/get-scope-342360687
     * @returns {Promise<HttpResponse>}
     */
    getScope() {
        const requestObj = {
            method: 'get',
            url: `/oauth/scope`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     *
     * @see https://developers.podio.com/doc/oauth-authorization/invalidate-grant-7997965
     * @returns {Promise<HttpResponse>}
     */
    invalidateGrant() {
        const requestObj = {
            method: 'post',
            url: `/oauth/grant/invalidate`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Invalidate all currently logined tokens of the user.
     *
     * @see https://developers.podio.com/doc/oauth-authorization/invalidate-tokens-7997943
     * @returns {Promise<HttpResponse>}
     */
    invalidateAllTokens() {
        const requestObj = {
            method: 'post',
            url: `/oauth/token/invalidate`,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Authorization;
